import React, { useState, useEffect } from 'react';
import { Formik, Form } from 'formik';

import * as Yup from 'yup';
import Box from '@material-ui/core/Box';
import { LOGOUT } from 'ConstComponents';
import {
    Select as LAPUPARTY_SELECT,
    SelectUsageReport as LAPUPUSAGE_SEARCH
} from 'Components/Api/LapuAccountingAPI';

import { SelectOperatorPrepaidAndDTH as OPERATOR_SELECT } from 'Components/Api/OperatorsApi';
import { MaterialDatePickerField } from 'Components/Inputes/MaterialDatePickerField';
import { MaterialSelect } from 'Components/Inputes/FormikMaterialSelect';
import {
    Container,
    Grid,
    Paper,
    Button,
    MenuItem,
    CircularProgress
} from '@material-ui/core';
import ReactTable from 'Components/ReactTable/ReactTable';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import { PLEASE_SELECT_VALID } from 'Components/Helper/Messages';
import HOCLoader from 'Components/Loader/HOCLoader';

const CustomContainer = HOCLoader(Container);

export const LapuUsage = () => {
    const classes = commonStyle();

    const [responseMessage, setResponseMessage] = useState('');
    const [isError, setIsError] = useState(false);
    const [loading, setLoading] = React.useState(false);
    const [severity, setSeverity] = useState('success');
    const [operatorList, setOperatorList] = useState([]);
    const [lapuPartyList, setLapuPartyList] = useState([]);

    const [itemList, setItemList] = useState([]);
    const [mainColumns, setMainColumns] = useState([]);

    const handleSubmit = async (values, { setSubmitting, resetForm }) => {
        if (loading) {
            setLoading(false);
            return;
        }

        var requestObj = JSON.stringify(values);
        const { isAuthorized, status, data } = await LAPUPUSAGE_SEARCH(
            requestObj
        );

        setLoading(false);
        if (!isAuthorized) LOGOUT();

        if (!status) {
            setIsError(true);
            setSeverity('error');
            setResponseMessage(data);

            return;
        }
        var d = JSON.parse(data);

        setItemList(d);
    };

    const FormValidationSchema = Yup.object({
        FromDate: Yup.date()
            .nullable(PLEASE_SELECT_VALID + 'from date')
            .required(PLEASE_SELECT_VALID + 'date')
            .max(new Date(), PLEASE_SELECT_VALID + 'from date')
            .typeError(PLEASE_SELECT_VALID + 'from date'),

        ToDate: Yup.date()
            .nullable(PLEASE_SELECT_VALID + 'date')
            .required(PLEASE_SELECT_VALID + 'date')
            .max(new Date(), PLEASE_SELECT_VALID + 'to date')
            .typeError(PLEASE_SELECT_VALID + 'to date'),

        OperatorID: Yup.string()
            .notOneOf(['0'], PLEASE_SELECT_VALID + 'operator')
            .required(PLEASE_SELECT_VALID + 'operator')
    });

    const selectData = async () => {
        const { isAuthorized, status, data } = await LAPUPUSAGE_SEARCH();

        setLoading(false);
        if (!isAuthorized) LOGOUT();

        if (!status) {
            setIsError(true);
            setResponseMessage(data);
            setSeverity('error');
            return;
        }
        var d = JSON.parse(data);

        setItemList(d);
    };

    const [FormObj, setFormObj] = useState({
        LapuPartyMasterID: 0,
        ToDate: new Date(),
        FromDate: new Date(),
        OperatorID: 0
    });

    const createColumns = () => {
        var columns = [];

        columns.push({
            label: '#',
            name: '',
            srno: true
        });

        columns.push({
            label: 'PartyName',
            name: 'PartyName'
        });
        columns.push({
            label: 'Operator',
            name: 'OperatorName'
        });

        columns.push({
            label: 'LapuNo',
            name: 'LapuNo'
        });
        columns.push({
            label: 'Total Transaction',
            name: 'TotalTransaction',
            numeric: true
        });
        columns.push({
            label: 'Total Trans Amt',
            name: 'TotalTransactionAmount',
            numeric: true
        });

        setMainColumns(columns);
    };

    const selectLapuParty = async () => {
        const response = await LAPUPARTY_SELECT();

        if (!response.isAuthorized) LOGOUT();

        if (!response.status) {
            setResponseMessage(response.data);
            setIsError(true);
        }

        var data = JSON.parse(response.data);
        setLapuPartyList(data);
    };

    const selectOperators = async () => {
        const response = await OPERATOR_SELECT();

        if (!response.isAuthorized) LOGOUT();

        if (!response.status) {
            setResponseMessage(response.data);
            setIsError(true);
        }

        var data = JSON.parse(response.data);
        setOperatorList(data);
    };

    useEffect(() => {
        selectLapuParty();
        selectOperators();
        createColumns();
        // selectData();
    }, []);

    const LapuPartyItems = lapuPartyList.map(
        ({ LapuPartyMasterID, PartyName }) => (
            <MenuItem key={LapuPartyMasterID} value={LapuPartyMasterID}>
                {PartyName}
            </MenuItem>
        )
    );

    const OperatorItems = operatorList.map(({ OperatorID, OperatorName }) => (
        <MenuItem key={OperatorID} value={OperatorID}>
            {OperatorName}
        </MenuItem>
    ));

    const UploadForm = (formProps) => {
        return (
            <Form>
                <Grid item xs={12}>
                    <Paper className={classes.PaperStyle}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={12} md={3} lg={3}>
                                <MaterialDatePickerField
                                    name="FromDate"
                                    label="From Date"
                                    maxDate={new Date()}
                                />
                            </Grid>

                            <Grid item xs={12} sm={12} md={3} lg={3}>
                                <MaterialDatePickerField
                                    name="ToDate"
                                    label="To Date"
                                    maxDate={new Date()}
                                />
                            </Grid>

                            <Grid item xs={12} sm={12} md={2} lg={2}>
                                <MaterialSelect
                                    name="OperatorID"
                                    label="Operator"
                                    title="Operator"
                                >
                                    <MenuItem key="0" value="0">
                                        Operator
                                    </MenuItem>
                                    {OperatorItems}
                                </MaterialSelect>
                            </Grid>
                            <Grid item xs={12} sm={12} md={2} lg={2}>
                                <MaterialSelect
                                    name="LapuPartyMasterID"
                                    label="LapuParty"
                                    title="LapuParty"
                                >
                                    <MenuItem key="0" value="0">
                                        LapuParty
                                    </MenuItem>
                                    {LapuPartyItems}
                                </MaterialSelect>
                            </Grid>
                        </Grid>
                    </Paper>
                </Grid>
                <Grid className={classes.footerGrid}>
                    <Box className={classes.flexReverse}>
                        <div className={classes.SubmitWrapper}>
                            <Button
                                type="submit"
                                title="Search"
                                className={classes.CustomPrimaryButtonStyle}
                                disabled={loading}
                            >
                                Search
                            </Button>
                            {loading && (
                                <CircularProgress
                                    size={24}
                                    className={classes.buttonProgress}
                                />
                            )}
                        </div>
                        <Button
                            type="reset"
                            variant="contained"
                            color="secondary"
                            title="Reset"
                            className={classes.CustomDangerButtonStyle}
                        >
                            Reset
                        </Button>
                    </Box>
                </Grid>
            </Form>
        );
    };

    return (
        <CustomContainer
            isLoading={loading}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            <Formik
                enableReinitialize={true}
                initialValues={FormObj}
                validationSchema={FormValidationSchema}
                onSubmit={handleSubmit}
                resetForm={FormObj}
            >
                {UploadForm}
            </Formik>

            <ReactTable data={itemList} columns={mainColumns} />
        </CustomContainer>
    );
};
